<app-header></app-header>
<div class="offset_nav">
<router-outlet></router-outlet>
</div>
<div style="position: relative ; z-index: 3;">
    <app-footer></app-footer>
</div>